import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';

import { StoreOptionsProps } from 'components/autocompletes/StoreAutoComplete';
import { useRequestListagem } from 'hooks/useRequestListagem';
import { ConfigPedidoProdutos } from 'pages/compra/configuracao-pedido/types';

export function useQueryProdutos(loja?: StoreOptionsProps | null) {
    const requestListagem = useRequestListagem();
    const { id } = useParams();

    return useQuery<ConfigPedidoProdutos>({
        queryKey: ['config-pedido-produtos', id, loja],
        queryFn: () =>
            requestListagem({
                url: `/gestao/configpedidoproduto/configpedido/${id}`,
                extraParams: [{ idLoja: loja?.idLoja }],
            }).then((res) => ({ configPedidoProdutos: res.data })),
    });
}
